import { FieldInputProps } from 'react-final-form';
import styled, { css } from 'styled-components';
import { useCameraViewContext } from '../../context';
import { Icon } from '@material-ui/core';
import { BinIcon } from 'components/Icons';
import { useVideoUrl } from '../../hooks/useVideoUrl';
import { useRemoveVideo } from 'pages/ListerVehicleUploadV2/hooks/useRemoveVideo';
import { UploadStatus, useVideoUploadStatus } from 'services/listerUploadVehicle/v2';
import { useFormVehicleId } from 'pages/ListerVehicleUploadV2/hooks/useFormVehicleId';
import AutoPlayVideo from 'components/AutoPlayVideo';

const Video = styled.div<{ isPlaceholder: boolean; isSelected?: boolean }>`
  background-color: ${props => {
    if (props.isSelected && !props.isPlaceholder) {
      return 'transparent';
    }
    if (!props.isPlaceholder) return 'inherit';
    return props.isSelected ? '#CCCCCC' : '#666666';
  }};
  min-height: 97px;
  max-height: 97px;
  aspect-ratio: 4 / 3;
  display: flex;
  flex: 0 0 auto;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;

  @media (orientation: landscape) {
    border: 2px solid #999999;
    min-height: 92px;
    max-height: 92px;
  }

  ${({ isSelected, isPlaceholder }) =>
    isSelected &&
    !isPlaceholder &&
    css`
      filter: grayscale(0.7);
    `}
`;

const StyledVideo = styled.video`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const BinIconWrapper = styled.div`
  position: absolute;
  width: 18px;
  height: 18px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  top: 4px;
  right: 4.6px;
  & svg {
    width: 12px;
    height: 12px;
  }
`;

export const VideoComponent = ({
  containerRef,
  ...input
}: FieldInputProps<any, HTMLElement> & { containerRef: React.RefObject<HTMLDivElement> }) => {
  const { selectVideoMode, isVideoMode } = useCameraViewContext();
  const openVideoMode = () => {
    selectVideoMode(input.name);
    queueMicrotask(() => {
      containerRef.current?.scrollTo({ top: 0, left: containerRef.current?.scrollWidth });
    });
  };
  const selected = isVideoMode === input.name;

  const url = useVideoUrl(input.value);
  const isPlaceholder = !url;

  const { level1SectionId } = useCameraViewContext();

  const removeVideo = useRemoveVideo(level1SectionId!);

  const vehicleId = useFormVehicleId();
  const uploadStatus = useVideoUploadStatus(vehicleId);
  const deleteDisabled = uploadStatus === UploadStatus.IN_PROGRESS || uploadStatus === UploadStatus.QUEUED;

  const handleRemove = async (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    e.stopPropagation();
    e.preventDefault();
    await removeVideo();
  };

  return (
    <Video isPlaceholder={isPlaceholder} isSelected={selected} onClick={openVideoMode}>
      {isPlaceholder && <VideoPlaceholder />}
      {!isPlaceholder && <AutoPlayVideo style={{ objectFit: 'cover' }} src={url} />}
      {!isPlaceholder && !deleteDisabled && (
        <BinIconWrapper onClick={handleRemove}>
          <BinIcon />
        </BinIconWrapper>
      )}
    </Video>
  );
};

const VideoPlaceholder = () => {
  return (
    <div>
      <Icon style={{ color: '#fff' }}>videocam</Icon>
    </div>
  );
};
